import { QuestionType, QuestionTypes } from '../../../../types/GlobalTypes';

export const checkIfCorrectAnswersRequired = (questionType: QuestionType) => {
  return (
    questionType === QuestionTypes.CLOSED ||
    questionType === QuestionTypes.OPEN_SHORT_TEXT ||
    questionType === QuestionTypes.ANIMATOR
  );
};
